package com.daytimegaming.ourdailyfinances.domain.dashboard

import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.asSharedFlow

class DashboardEventBus {
    private val _events = MutableSharedFlow<String?>(extraBufferCapacity = 64)
    val events: SharedFlow<String?> = _events.asSharedFlow()

    suspend fun dashboardChanged(dashboardId: String? = null) {
        _events.emit(dashboardId)
    }

    fun tryEmitDashboardChanged(dashboardId: String? = null) {
        _events.tryEmit(dashboardId)
    }
}
